// dependencies
import { Disclaimers, PricePoint, defineMessages, TopLegals, LanguageSwitcher } from 'ouisys-component-library';
import * as RDS from 'ouisys-engine/dist/common-types/RemoteDataState';
import strategy from 'ouisys-engine/dist/flows/strategy';

import { identifyStrategy, StrategyFlowActionMaps, tracker } from 'ouisys-engine/dist/reducers/strategy';
import {
  IDENTIFYMSISDNEntryFailure,
  IDENTIFYMSISDNEntrySuccess,
  IIdenyifyFlowByMsisdnSumbitNextData
} from 'ouisys-engine/dist/reducers/strategy/StrategyTypes';
import store from 'ouisys-engine/dist/store';
import { IApplicationState } from 'ouisys-engine/dist/store/reducers';
import { setOnLoadUtilities } from 'ouisys-engine/dist/utilities';
import { getConfig } from 'ouisys-phone-input/dist/common/PhoneInput';
import React, { useEffect, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';

// local
import './Bloxz.scss';
import Loader from './components/Loader';
import OperatorSelection from './components/OperatorSelection';
import PhoneNumberEntryStep from './components/PhoneNumberEntryStep';
import PreLander from './components/PreLander';
import Click2smsFlow from './flows/Click2smsFlow';
import CreditCardFlow from './flows/CreditCardFlow';
import MoFlow from './flows/MoFlow';
import MoRedirFlow from './flows/MoRedirFlow';
import OneClickFlow from './flows/OneClickFlow';
import PinFlow from './flows/PinFlow';
import UssdFlow from './flows/UssdFlow';
import { legals, Translate, TranslationProvider } from './localization/index';
import './Root.scss';
import searchToObject from './utils/searchToObject';

import CustomLoader from './components/CustomLoader';

// error messages messages which might come from backend
const defaultMessages = defineMessages({
  InvalidMSISDN: {
    id: 'InvalidMSISDN',
    defaultMessage: 'This mobile number is incorrect, try again'
  },
  AlreadySubscribed: {
    id: 'AlreadySubscribed',
    defaultMessage: 'You are already a subscriber!'
  },
  UnknownError: {
    id: 'UnknownError',
    defaultMessage: 'An unknown error occurred.'
  },
  InvalidPIN: {
    id: 'InvalidPIN',
    defaultMessage: 'Please enter the correct PIN that you received on your phone'
  },
  SessionBlocked: {
    id: 'SessionBlocked',
    defaultMessage: 'Session Blocked!'
  },
  TooEarly: {
    id: 'TooEarly',
    defaultMessage: 'You must first submit a mobile number'
  },
  didnt_receive_pin_yet: {
    id: 'didnt_receive_pin_yet',
    defaultMessage: "Didn't receive PIN yet?"
  }
});

interface HOCProps {}

const PRIMARY_LOCALE = 'vi';
// const SECONDARY_LOCALE = 'ar';
// const PRIMARY_LOCALE_TEXT = 'English';
// const SECONDARY_LOCALE_TEXT = 'عربى';

const Root = ({}: HOCProps) => {
  const [locale, setLocale] = useState(PRIMARY_LOCALE);
  const [operator, setOperator] = useState<string | null>(null);
  const [msisdn, setMsisdn] = useState<string>(getConfig(process.env.country).commonPrefix);
  const [skipPrelander, setPrelander] = useState(false);
  const dispatch = useDispatch();
  const { currentState } = useSelector((state: IApplicationState) => state.strategy);
  const urlParams = searchToObject();
  const [isModal, setModal] = useState(false);
  const [isOverlay, setOverlay] = useState(false);
  const { d_theme, d_locale } = urlParams as { d_theme: string; d_locale: string };
  const logoImg = require('./assets/imgs/logo.svg');
  const checkedIcon = require('./assets/imgs/check-load.svg');
  const downloadIcon = require('./assets/imgs/link.svg');
  // show or hide pre-lander
  const checkSkipPrelander = () => {
    if (urlParams['skip-prelander']) {
      setPrelander(urlParams['skip-prelander'] === 'true');
    }
  };

  const switchLang = (lang: string) => {
    console.log('switchLang', lang);
    setLocale(lang);
    if (typeof window !== 'undefined') {
      document.getElementsByTagName('html')[0].setAttribute('lang', lang);
    }
  };

  const divFocus = () => {
    if (typeof window !== 'undefined') {

      document.querySelector('#divFocus').className = 'shake-horizontal';

      setTimeout(()=>{

        document.querySelector('#divFocus').className = ' ';

      },500)


    }
  };

  const identifyFlowByMsisdnInterface = (
    rds: RDS.RemoteDataState<IDENTIFYMSISDNEntryFailure, IDENTIFYMSISDNEntrySuccess>,
    nextData: IIdenyifyFlowByMsisdnSumbitNextData
  ) => {
    const { nextAction } = nextData;
    return (
      <PhoneNumberEntryStep
        msisdn={msisdn}
        rds={rds}
        onEnd={(msisdn) => {
          setMsisdn(msisdn);
          dispatch(StrategyFlowActionMaps[nextAction](msisdn));
        }}
        locale={locale}
      />
    );
  };

  useEffect(() => {
    dispatch(identifyStrategy());
    checkSkipPrelander();

    // set locale based on url designer param
    if (d_locale && !!legals[d_locale]) {
      setLocale(d_locale);
    }

    setOnLoadUtilities((currentState as any)?.result?.config);
  }, []);

  return (
    <TranslationProvider locale={locale}>
      <div className={`bx-guides bx-${locale} theme-${d_theme === 'dark' ? 'dark' : 'light'}`}>

      


        <div className="custom-wrap">
          <div className="custom-header">
            <img src={logoImg} alt="" className="logo" />

            {/* <a href='https://www.google.com' target='_self' onClick={()=> tracker.customEvent("main-page","close-btn","click") }><img src={require('../src/assets/imgs/close-btn.svg')} alt="" className="close" /></a> */}

          </div>

          <div className="custom-content">
            
            {/* pre-lander */}
            {!skipPrelander && <PreLander showHolder={() => {
              tracker.advancedInPreFlow("advance-auto","step-1");
              setPrelander(true);
              }}/>}

            <CustomLoader activeLoader={isOverlay}/>

            <div className={`custom-holder with-prelander-${skipPrelander}`} onClick={(ev) => ev.stopPropagation()}>
              <img src={downloadIcon} alt="" className="downloadIcon bounceIn" />
              {strategy({
                identifyFlowByMsisdn: (rds, nextData) => identifyFlowByMsisdnInterface(rds, nextData),
                identifyFlowByOperatorSelect: (data) => <OperatorSelection setOperator={setOperator} {...data} />,
                pinFlow: (nextData) => (
                  <PinFlow
                    nextData={nextData}
                    locale={locale}
                    msisdn={msisdn}
                    operator={operator}
                    setMsisdn={setMsisdn}
                  />
                ),
                moFlow: (nextData) => (
                  <MoFlow
                    nextData={nextData}
                    locale={locale}
                    msisdn={msisdn}
                    operator={operator}
                    setMsisdn={setMsisdn}
                  />
                ),
                moRedirFlow: (nextData) => (
                  <MoRedirFlow
                    nextData={nextData}
                    locale={locale}
                    msisdn={msisdn}
                    operator={operator}
                    setMsisdn={setMsisdn}
                  />
                ),
                oneClickFlow: (nextData) => <OneClickFlow nextData={nextData} locale={locale} operator={operator} redirectPage={()=>setOverlay(true)} />,
                click2smsFlow: (nextData) => <Click2smsFlow nextData={nextData} locale={locale} operator={operator} />,
                ussdFlow: (nextData) => (
                  <UssdFlow
                    nextData={nextData}
                    locale={locale}
                    msisdn={msisdn}
                    operator={operator}
                    setMsisdn={setMsisdn}
                  />
                ),
                creditCardFlow: (nextData) => <CreditCardFlow nextData={nextData} locale={locale} />
              })(currentState)}
            </div>

            {RDS.WhenLoading(null, () => (
              <div className="loading-wrapper">
                <Loader />
                <div>
                  <Translate id="loadingLabel" defaultMessage="Please wait..." />
                </div>
              </div>
            ))(currentState?.result as RDS.RemoteDataState<unknown, unknown>)}
          </div>
        </div>

        <div className="custom-footer">
          <img src={require("../src/assets/imgs/trust.svg")} alt="" className='trust'/>
          <div className="legalArea">
            {process.env.country !== 'qa' && (
              <PricePoint className="price-point" locale={locale} legals={legals} />
            )}
            <Disclaimers className="disclaimer" locale={locale} legals={legals}  />
        </div>
        </div>
      </div>
    </TranslationProvider>
  );
};

const R = () => (
  <Provider store={store}>
    <Root />
  </Provider>
);

export default R;
